<template>
  <div id="app">
    <div class="App" :style="{backgroundColor:backgroundcolor}" :class="isPop?'noscroll':''">
      <!--S Loading-->
      <div v-show="isloading" class="loading">
        <div class="loading-point" />
      </div>
      <!--E Loading-->
      <div class="main-content" :style="{paddingBottom: paddingBottom}">
        <div v-show="!isloading" class="wrapper" :class="isPop?'blur':''" :style="{'padding-top': Top, backgroundImage:'url('+ backgroundImage +')'}">
          <div v-show="rule_link" class="active-rule" @click="toRules">活动<br>规则</div>
          <!--S 走马灯  产品暂时去掉这个功能-->
          <!--  <couponSwiper></couponSwiper>-->
          <!--E 走马灯-->
          <!--S 领券模块-->
          <couponList v-show="dataForCoupon.isget" :coupon-list="coupon_comp_list" :is-app="isApp" :coupon="dataForCoupon" :total-value="totalValue" :guide-data="guideData" />
          <couponBox
            v-show="!dataForCoupon.isget"
            ref="couponRef"
            :new-user="newUser"
            :is-app="isApp"
            :loginstatus="loginstatus"
            :coupon="dataForCoupon"
            :guide-data="guideData"
            @couponMsgFn="showcouponMsgFn"
            @wxh5LoginSuccess="wxh5LoginSuccess"
            @loginSuccess="loginSuccess"
            @getcoupon="getCouponFn"
          />
          <!--E 领券模块-->
          <!--S 超链接模块-->
          <linkBox v-if="linkdata.length > 0" :linkdata="linkdata" />
          <!--E 超链接模块-->
          <!--S 活动规则-->
          <ruleBox v-if="ruleData" :rule-data="ruleData" />
        <!--E 活动规则-->
        </div>
        <!--S 页脚-->
        <Footer />
      <!--E 页脚-->
      </div>
      <coupon-btn
        v-show="dataForCoupon.isget"
        class="content-bot"
        :data-for-coupon="dataForCoupon"
        :coupon-list="coupon_comp_list"
        :is-app="isApp === 'wxh5' ? 'other' : isApp"
        :wechat_link="dataForCoupon.wechat_link"
        :wechat_url="dataForCoupon.wechat_url"
        :tel="dataForCoupon.tel"
        :total-value="totalValue"
        :guide-data="guideData"
        @caclPadding="caclPadding"
      />
      <!--弹窗-->
      <popBox v-if="isPop" :popdata="popdata" @close="closePop" />
    <!--E弹窗-->
    </div>
  </div>
</template>

<script>
/* global gdt */
import Env from '@common/libs/util.env.js'
import { getQueryString } from '@common/libs/util.url.js'
import { Deferred } from '@common/libs/util.async.js'
import vm from '@common/components/vue/dida/toast/vm_toast.js'
import couponBox from './components/couponBox'
import linkBox from './components/linkBox'
import ruleBox from './components/ruleBox'
import popBox from './components/popBox'
import couponList from './components/couponList'
import couponBtn from './components/couponBtn'
import Footer from './components/footer'
// import couponSwiper from './components/couponSwiper';
import { shareByAppBtn } from '@common/libs/old_____util.share.js'
import { getCouponMsg, receiveCpsH5Coupon, checkHaveReceive, wechatMKT, getAccessToken, official } from './api/api.js'
import { newReceiveCpsH5Coupon, tencentattribution } from './api/newapi'
import { shareByWX } from '@common/libs/util.share.js'
import { addStat2 } from '@/utils/stat.util'
import { getAppClient } from '@/utils/environment.util'

const CID = getQueryString('cid') || getQueryString('user_cid') || getQueryString('userCid') || ''
const source_id = getQueryString('source_id') || 'app'
const goodCid = getQueryString('goodCid')
// const fromSubLogin = getQueryString('from') || ''
const access_token = getQueryString('access_token')
const PID = getQueryString('PID') || '' // WEBHF-973
const gdt_vid = getQueryString('gdt_vid') // 微信渠道投放埋点
const qz_gdt = getQueryString('qz_gdt') || '' // CMS-2546非微信渠道投放埋点
const code = getQueryString('code') || ''
const channel = getQueryString('channel') || '' // DIDAWEB-1313 渠道为小象H5登录
const b_config = getQueryString('b_config') || '' // 小B渠道
const app_lient = getAppClient() // 获取环境
// const notoapp = getQueryString('notoapp') || null; // 是否跳转app

var originLink
if (Env.isEnvOnline) {
  //  线上
  originLink = 'https://' + window.location.host
} else if (Env.isEnvECS) {
  //  aliyun
  originLink = 'https://' + window.location.host
} else {
  // 兼容本地故使用了http
  originLink = 'http://' + window.location.host
}
const search = '?goodCid=' + goodCid + '&PID=' + PID + (getQueryString('type') ? '&type=' + getQueryString('type') : '')
export default {
  components: {
    // couponSwiper,
    couponList,
    couponBox,
    linkBox,
    ruleBox,
    popBox,
    couponBtn,
    Footer
  },
  data() {
    return {
      paddingBottom: '0rem', // 4.06rem
      source_id: source_id,
      isloading: true,
      isPop: 0, // 0-无，
      couponList: [], // 优惠券列表
      totalValue: '', // 优惠券总价
      isApp: 'app', // app:app内，minwx:小程序，other:第三方
      loginstatus: true, // 是否为登陆状态
      phone: '',
      user_cid: '',
      access_token: '',
      Top: '4.98rem', // 页面开始显示的距上高度（可配置）
      backgroundcolor: '#e1baf4', // 背景颜色（头图为渐变长度不够需要拼接底色（可配置））
      backgroundImage: 'https://static.didapinche.com/pics/g/u1tswx9392pWEBHF-844%E5%A4%87%E4%BB%BD%203.png', // 背景头图（可配置）
      title_image: '', // 领取成功后的背景头图（可配置）
      // 优惠券模块参数
      dataForCoupon: {
        title: '',
        subtitle: '',
        name: '',
        desc: [],
        // desc: ['含3张10元顺风车出行券', '含的张嘀嗒元顺风车出行券含3张10元顺风车出行券', '含3张10元顺风车出行券'],
        value: 0,
        wechat_url: '',
        wechat_link: 'https://mp.weixin.qq.com/s/WiwYxQpe6PIUtva0Dv7lTw', // 公众号默认值
        discount: false, // 折扣券/非折扣券
        isget: false, // 是否已领取
        isover: false, // 失效,
        tel: ''
      },
      // coupondata: null,
      // coupondata: {
      // title: '嘀嗒送你优惠大礼包',
      // subtitle: '配置文案文案文案文案文案文案文案文。',
      // name: '50元顺风券包',
      // desc: [],
      // // desc: ['含3张10元顺风车出行券', '含的张嘀嗒元顺风车出行券含3张10元顺风车出行券', '含3张10元顺风车出行券'],
      // value: 4,
      // codeurl: 'https://static.didapinche.com/pics/g/hantai2020311_hantaibg01.jpg',
      // discount: false, // 折扣券/非折扣券
      // isget: false, // 是否已领取
      // isover: false, // 失效,
      // tel: ''
      // },
      // 超链接模块参数
      linkdata: [
        //   {
        //   title: '',
        //   subtitle: '',
        //   img_url: '',
        //   link: ''
        // }
      ],
      // 优惠券详情弹窗模块参数
      popdata: {
        title: '',
        txt: []
      },
      // 活动规则模块参数
      ruleData: '',
      shareData: {
        title: '你有一张优惠券待领取',
        subtitle: '快点击查看吧！',
        minipg_imgurl: 'https://static.didapinche.com/pics/g/carpoolinvite_wxshare_miniShare.jpg', // 小程序分享图
        img_url: 'https://static.didapinche.com/pics/g/carpoolinvite2020_coupontemplateShare.jpg' // 125X125小图
      },
      guideData: {
        download_guide_display: 0, // 是否显示下载app
        applet_guide_display: 0, // 是否显示打开小程序
        applet_type: '', // taxi 出租车  'carpool' 顺风车
        applet_link: '', // 跳转到小程序的url
        ios_download_link: '' // ios渠道下载地址
      },
      // 以下是微信授权相关
      newUser: -1, // 微信号没有绑定的手机号 newUser = 1
      wxopenId: '', // 静默登录openId
      wxAccessToken: '', // 静默登录accessToken 不同于登录的token
      showWxPop: false, // 未授权的透明弹窗，用户点击触发再次授权
      rule_link: ''
    }
  },
  computed: {
    // 处理优惠券列表数据（折扣、有效期）
    coupon_comp_list() {
      const length = this.couponList.length
      const couponList = this.couponList
      for (let i = 0; i < length; i++) {
        if (couponList[i]['discount']) {
          if (((+couponList[i]['discount']).toFixed(2)).substr(3, 1) === '0') {
            couponList[i]['discount'] = couponList[i]['discount'].substr(0, 3) * 10
            couponList[i]['discountDiscount'] = true
          } else {
            couponList[i]['discount'] = couponList[i]['discount'] * 100
            couponList[i]['discountDiscount'] = false
          }
        }
        if (couponList[i]['price']) {
          if (((+couponList[i]['price']).toFixed(2)).substr(couponList[i]['price'].length - 2, 2) === '00') {
            couponList[i]['price'] = couponList[i]['price'].substr(0, couponList[i]['price'].length - 3)
          }
        }
        if (!(couponList[i]['type'] === 0 || couponList[i]['type'] === 1 || couponList[i]['type'] === 2)) {
          couponList[i]['type'] = 1
        }
        couponList[i]['endTime'] = this.handleTime(new Date(couponList[i].validEndTime))
        couponList[i]['validTime'] = (new Date(+couponList[i].validBeginTime).getMonth() + 1) + '月' + new Date(+couponList[i].validBeginTime).getDate() + '日 - ' + (new Date(+couponList[i].validEndTime).getMonth() + 1) + '月' + new Date(+couponList[i].validEndTime).getDate() + '日'
      }
      return couponList
    }
  },
  created() {
    this.initData()
  },
  activated() {
    this.initData()
  },
  beforeDestroy() {
    if (Env.inWechat) {
      window.removeEventListener('popstate', this.goBack, false)
    }
  },
  methods: {
    toRules() {
      window.location.href = this.rule_link
    },
    /*
    * 静默登录会导致返回多一层, 此处解决返回问题
    */
    resetGoBack() {
      // 安卓微信H5需要交互才出发popstate
      // 以下类似于触发解决
      try {
        window.tbs_bridge.nativeExec('network', 'type', 0, null)
      } catch (e) {
        // console.error(e);
      }
      pushHistory()
      window.addEventListener('popstate', this.goBack, false)
      function pushHistory() {
        var state = {
          title: 'title',
          url: '#'
        }
        window.history.pushState(state, 'title', '#')
      }
    },
    /*
    * 配合上面从写返回
    */
    goBack() {
      if (code) {
        window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
      } else {
        window.history.go(-1)
      }
    },
    caclPadding(val) {
      this.paddingBottom = val + 'rem'
    },
    /**
     * @description: 处理时间
     * @param {*}
     * @return {*}
     */
    handleTime(time) {
      const year = time.getFullYear()
      const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
      const day = time.getDate()
      const hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours()
      const min = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes()
      const sec = time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
      return year + '.' + month + '.' + day + '.' + hour + '.' + min + '.' + sec
    },
    initData() {
      setTimeout(() => {
        this.isloading = false
      }, 3000)
      this.__wxReadyDeferred = new Deferred()
      if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
        document.addEventListener('WeixinJSBridgeReady', () => {
          this.__wxReadyDeferred.resolve()
        }, false)
      } else {
        this.__wxReadyDeferred.resolve()
      }
      this.user_cid = ''
      if (channel === 'xiaoxiang') {
        this.initoutLink()
        return
      }
      if (Env.inApplication) {
        // app内
        this.initapp()
        // console.log('app内===>', this.isApp)
      } else if (Env.inWechat || getAppClient(true)) {
        const that = this
        app_lient.getEnv(function(res) {
          if (res.miniprogram) {
            // 小程序内
            that.initWx()
          } else {
            // 微信非小程序环境
            that.initoutLink('wxh5')
            that.resetGoBack()
          }
        })
      } else {
        this.initoutLink()
        // console.log('H5===>', this.isApp)
      }
    },
    sharePath(url) {
      return 'pages/index?type=share&sharepath=' + encodeURIComponent('/pages/webviewact?url=' + encodeURIComponent(url))
    },
    // 小程序分享通讯
    wxready(data) {
      // 只在小程序中调用分享
      if (Env.inWechat || getAppClient(true)) {
        const that = this
        app_lient.getEnv(function(res) {
          if (res.miniprogram) {
            // 小程序内
            that.__wxReadyDeferred.promise.then(() => {
              // eslint-disable-next-line no-undef
              app_lient.postMessage({
                data: {
                  imageUrl: data.minipg_imgurl,
                  title: data.title,
                  path: that.sharePath(originLink + window.location.pathname + search)
                }
              })
            }).catch(() => {})
          }
        })
      }
    },
    // app初始化
    initapp() {
      // app内
      this.user_cid = CID
      this.access_token = access_token
      this.isApp = 'app'
      if (!PID) {
        // 无pid 跳转首页
        window.location = 'didapinche://home'
      }
      if (!CID) {
        window.location = 'didapinche://login'
        this.loginstatus = false
      } else {
        this.pageDataFn() // 优惠券信息
        this.isCouponGet() // 是否领取过
      }
    },
    // 微信小程序初始化
    initWx() {
      this.user_cid = CID
      this.access_token = access_token
      this.isApp = 'minwx'
      this.loginstatus = true
      if (!PID) {
        // 无pid 跳转首页
        // eslint-disable-next-line no-undef
        app_lient.redirectTo({ url: './index' })
        return
      }

      // if (!this.user_cid) {
      //   this.loginstatus = false
      //   const url = originLink + window.location.pathname
      //   // eslint-disable-next-line no-undef
      //   app_lient.navigateTo({ url: '/pagesWebView/subLogin/subLogin?backurl=' + btoa(encodeURIComponent((JSON.stringify(url)))) })
      //   app_lient.redirectTo({ url: './uniformlogin?backurl=' + encodeURIComponent('/pages/webviewact?url=' + encodeURIComponent(url)) })
      //   return
      // } else {
      //   this.pageDataFn() // 优惠券信息
      //   this.isCouponGet() // 是否领取过
      // }
      if (!this.user_cid) {
        this.loginstatus = false
      }
      if (this.user_cid) {
        this.isCouponGet() // 是否领取过
      }
      this.pageDataFn() // 优惠券信息
    },
    // 微信&第三方初始化
    initoutLink(type) {
      // 存在type且为wxh5为微信H5环境
      this.user_cid = localStorage.getItem('didacoupontemeplete_cid')
      this.access_token = localStorage.getItem('didacoupontemeplete_token')
      this.isApp = type || 'other'
      this.pageDataFn() // 优惠券信息
      if (!PID) {
        // 无pid 跳转首页
        window.location = 'https://www.didapinche.com/adh5/static/toapp/toapp.html'
        return
      }

      // console.log('initoutLink   code===>', code)
      // if (this.isApp === 'wxh5' && code && code !== sessionStorage.getItem('code')) {
      if (this.isApp === 'wxh5' && code && code !== sessionStorage.getItem('code')) {
        this.wxh5login()
      }
      if (this.user_cid) {
        this.isCouponGet() // 是否领取过
      } else {
        this.loginstatus = false
      }
    },
    wxh5login() {
      const data = {
        appid: 'wxf18a88f56d23da94',
        secret: '721d6a48cdfc0635deecf42669252705',
        code: code,
        grant_type: 'authorization_code'
      }
      // 拿着code去获取用户状态，老用户返回cid和token
      getAccessToken(data).then(res => {
        if (res.data.code === 0) {
          this.wxopenId = res.data.openId
          this.wxAccessToken = res.data.accessToken
          const newdata = {
            phone: '',
            openid: this.wxopenId,
            accessToken: this.wxAccessToken
          }
          official(newdata).then(res => {
            if (res.data.code === 0) {
              sessionStorage.setItem('code', code)

              // console.log('official res.data===>', res.data)
              // 微信号没有绑定的手机号 newUser = 1
              if (res.data.newUser === 1) {
                // 展示去登陆的输入框，绑定手机号
                this.newUser = res.data.newUser
                // this.loginshow = true;
              } else {
                localStorage.setItem('didacoupontemeplete_phone', res.data.phone)
                localStorage.setItem('didacoupontemeplete_cid', res.data.cid)
                localStorage.setItem('didacoupontemeplete_token', res.data.access_token)
                // 小B是否是新用户
                localStorage.setItem('newly', res.data.newly)
                this.loginSuccess()
              }
            } else {
              vm.$didafe.toast(res.data.message)
            }
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    // 页面信息
    pageDataFn() {
      /*
      * 优惠券：优惠券详情，是否过期，是否领取
      * 公众号图片是否配置
      * 超链接模块是否配置
      * 活动规则是否配置
      * 是否可分享
      * */
      const obj = {
        goodsCid: goodCid,
        pid: PID
      }
      getCouponMsg(obj).then(res => {
        if (res.data.code === 0) {
          const couponData = res.data.ret.couponData ? res.data.ret.couponData : this.dataForCoupon
          Object.assign(this.dataForCoupon, couponData)
          this.dataForCoupon.isover = res.data.ret.expireStatus === 1 // 是否过期
          // 小程序修改登录后不再返回 from=subLogin（已与张练确认）,现H5兼容小程序登录返回的场景
          const local_loginStatus = localStorage.getItem('local_loginStatus')
          if ((this.isApp === 'minwx' || getAppClient(true) === 'my') && (local_loginStatus === '1' && CID)) {
            localStorage.removeItem('local_loginStatus')
          // if ((this.isApp === 'minwx' || getAppClient(true) === 'my') && fromSubLogin === 'subLogin') {
            this.getCouponFn()
          }
          // 页面背景
          if (res.data.ret.commonStyle) {
            const commonStyle = res.data.ret.commonStyle
            this.backgroundcolor = commonStyle.background_color ? commonStyle.background_color : '#e1baf4'
            this.backgroundImage = commonStyle.background_image ? commonStyle.background_image : 'https://static.didapinche.com/pics/g/u1tswx9392pWEBHF-844%E5%A4%87%E4%BB%BD%203.png'
            this.title_image = commonStyle.title_image ? commonStyle.title_image : 'https://static.didapinche.com/pics/g/u1tswx9392pWEBHF-844%E5%A4%87%E4%BB%BD%203.png'
            this.Top = commonStyle.height ? parseFloat(commonStyle.height) / 100 + 'rem' : '4.98rem'
          }
          if (res.data.ret && res.data.ret.guideData) {
            this.guideData = res.data.ret.guideData
          }
          // 分享
          // if (res.data.ret.shareDate) {
          const share = res.data.ret.shareDate
          this.shareData.title = share && share.title ? share.title : this.dataForCoupon.discount ? '你有一张' + this.dataForCoupon.value + '折优惠券待领取。' : '你有' + this.dataForCoupon.value + '元优惠券待领取。'
          this.shareData.subtitle = share && share.subtitle ? share.subtitle : '快点击查看吧！'
          this.shareData.img_url = share && share.img_url ? share.img_url : 'https://static.didapinche.com/pics/g/carpoolinvite2020_coupontemplateShare.jpg'
          this.shareData.minipg_imgurl = share && share.minipg_imgurl ? share.minipg_imgurl : 'https://static.didapinche.com/pics/g/carpoolinvite_wxshare_miniShare.jpg'
          this.wxready(this.shareData) // 小程序通信
          this.shareByApp(this.shareData) // app分享
          this.wxSencondShare(this.shareData) // 微信二次分享
          // }
          // link
          this.linkdata = res.data.ret.linkData ? res.data.ret.linkData : this.linkdata
          this.rule_link = res.data.ret.ruleLink ? res.data.ret.ruleLink : ''
          // rule
          this.ruleData = res.data.ret.rule ? res.data.ret.rule : ''
          // 第三方手机号
          if ((this.isApp === 'other' || this.isApp === 'wxh5')) {
            this.dataForCoupon['tel'] = localStorage.getItem('didacoupontemeplete_phone') || ''
          }
          this.isloading = false
          // let ruleStr = '3张10元顺风车出行券文案文奋斗奋斗是非放松的方0元顺风车出行券文案文奋斗奋斗是非放松的方0元顺风车出行券文案文奋斗奋斗是非放松的方式\n\n\n福多寿得失含斗奋斗是非斗奋斗是非\n顺风车出行券文案文奋斗奋斗是非放松的方式\n奋斗奋斗是非放松的方0元顺风车发送到发送到发送到\n3张10元顺风车出行券文案文奋斗奋斗是非放松的方式\n\n\n多福多寿得失含\n顺风车出行券文案文奋斗奋斗是非放松的方式\nf发送到发送到发送到\n3张10元顺风车出行券文案文奋斗奋斗是非放松的方式\n\n\n多福多寿得失含\n顺风车出行券文案文奋斗奋斗是非放松的方式\nf发送到发送到发送到';
          // ！！！！！接口成功后设置优惠券规则！！！！！
          const ruleStr = this.dataForCoupon.desc || ''
          if (ruleStr) {
            this.dataForCoupon.desc = this.transCouponMsg(ruleStr)
            this.popdata.title = this.dataForCoupon.name
            this.popdata.txt = this.transCouponMsg(ruleStr)
            this.$refs.couponRef.setCouponMsg()
          }
          // 跟踪渠道：1-不启用、2-头条、3-腾讯 DIDAWEB-2204
          this.trackChannel = res.data.ret.trackChannel ? res.data.ret.trackChannel : 1
          // trackSecret 只有头条需要跟踪秘钥
          this.trackSecret = res.data.ret.trackSecret ? res.data.ret.trackSecret : ''
          // 动态初始化腾讯id, 防止变化
          if (this.trackChannel !== 2) {
            gdt('init', this.trackSecret ? this.trackSecret : '1111850894')
            gdt('track', 'PAGE_VIEW')
            // console.log('非头条trackSecret=' + this.trackSecret)
          }
          this.inviteChannel = res.data.ret.inviteChannel
        } else if (res.data.code === 534) {
          // 该请求不符合规范
          this.$didafe.toast(res.data.msg, { wordWrap: 'auto' })
          if (this.isApp === 'app') {
            window.location = 'didapinche://home'
          } else if (this.isApp === 'minwx') {
            // 无pid 跳转首页
            // eslint-disable-next-line no-undef
            app_lient.redirectTo({ url: './index' })
          } else {
            window.location = 'https://www.didapinche.com/adh5/static/toapp/toapp.html'
          }
        } else {
          this.$didafe.toast(res.data.msg, { wordWrap: 'auto' })
          this.wxready(this.shareData) // 小程序通信
        }
      }).catch(e => {
        this.wxready(this.shareData) // 小程序通信
        console.log(e)
      })
    },
    // 优惠券是否领取过
    isCouponGet() {
      // 外部浏览器环境
      if (this.isApp === 'other' && (qz_gdt || gdt_vid)) {
        // 小程序url拼接existed（0-新用户 1-老用户）
        // 其他手机号验证码登录 newly：是否新用户（1-否 0-是）
        // 广告商上报
        let action_type = ''
        if (this.isApp === 'minwx') {
          action_type = getQueryString('existed') === '0' ? 'REGISTER' : 'LOGIN'
        } else if (this.isApp === 'other') {
          action_type = this.$root.newly === 0 ? 'REGISTER' : 'LOGIN'
        }
        const data = {
          cid: this.user_cid || localStorage.getItem('didacoupontemeplete_cid'),
          type: 2, // 1:发生点击；2:发生注册/登陆后上报
          action_type, // REGISTER：注册；LOGIN：登陆
          click_id: qz_gdt || gdt_vid
        }
        tencentattribution(data, this.access_token).then(res => {
          console.log(res)
        })
      }
      const obj = {
        userCid: this.user_cid,
        goodsCid: goodCid
      }
      return checkHaveReceive(obj, this.access_token).then(res => {
        if (res.data.code === 0) {
          // 1:未领取 2:已领取 3:已失效
          if (res.data.ret.status === '1') {
            this.loginstatus = false
            this.dataForCoupon.isget = false
          } else if (res.data.ret.status === '2') {
            this.dataForCoupon.isget = true
            this.loginstatus = true
            if (res.data.ret && res.data.ret.guideData) {
              this.guideData = res.data.ret.guideData
            }
            // res.data.ret.couponList = [
            //   {
            //     name: '仅app城际', // 券名称
            //     discountFlag: true, // 是否折扣券
            //     discount: '0.5', // 折扣
            //     price: '5', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '仅app城际', // 券名称
            //     discountFlag: true, // 是否折扣券
            //     discount: '0.50', // 折扣
            //     price: '10', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '仅app城际', // 券名称
            //     discountFlag: true, // 是否折扣券
            //     discount: '0.88', // 折扣
            //     price: '14', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '仅app城际', // 券名称
            //     discountFlag: true, // 是否折扣券
            //     discount: '0.88', // 折扣
            //     price: '7', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '互斥个鬼哦', // 券名称
            //     discountFlag: false, // 是否折扣券
            //     price: '5', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '互斥个鬼哦', // 券名称
            //     discountFlag: false, // 是否折扣券
            //     price: '5.5', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '互斥个鬼哦', // 券名称
            //     discountFlag: false, // 是否折扣券
            //     price: '5.55', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   },
            //   {
            //     name: '互斥个鬼哦', // 券名称
            //     discountFlag: false, // 是否折扣券
            //     price: '55.55', // 面值
            //     validBeginTime: '1600768145000', // 有效开始
            //     validEndTime: '1609343999000' // 有效结束
            //   }
            // ];

            this.couponList = res.data.ret && res.data.ret.couponList ? res.data.ret.couponList : []
            this.totalValue = res.data.ret && res.data.ret.totalValue ? res.data.ret.totalValue : ''
            this.backgroundImage = this.title_image || 'https://static.didapinche.com/pics/g/u1tswx9392pWEBHF-844%E5%A4%87%E4%BB%BD%203.png'
          } else if (res.data.ret.status === '3') {
            this.dataForCoupon.isover = true
            this.loginstatus = true
            this.$didafe.toast('活动已下架')
          }
        } else if (res.data.code === 401) {
          //  账号信息过期
          this.loginstatus = false
          localStorage.removeItem('didacoupontemeplete_phone')
          localStorage.removeItem('didacoupontemeplete_cid')
          localStorage.removeItem('didacoupontemeplete_token')
        } else {
          this.$didafe.toast(res.data.msg, { wordWrap: 'auto' })
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // 领取优惠券
    getCouponFn() {
      addStat2('领券模板_点击领取优惠券', CID, goodCid, this.$root.envir) // 添加埋点
      const obj = {
        userCid: this.user_cid || localStorage.getItem('didacoupontemeplete_cid'),
        goodsCid: goodCid,
        pid: PID,
        inviteChannel: this.inviteChannel,
        env: this.$root.envir
      }
      const [configCode, inviteUserCode] = b_config.split('_')
      let isFromXiaoB = false
      if (b_config && configCode.length === 10 && inviteUserCode.length === 10) {
        isFromXiaoB = true
        Object.assign(obj, {
          inviteUserCode: inviteUserCode,
          configCode: configCode,
          registeMark: localStorage.getItem('newly')
        })
      }
      if (isFromXiaoB) { // true 调用小B接口
        newReceiveCpsH5Coupon(obj, this.access_token).then(res => {
          this.conponRes(res)
        }).catch(e => {
          console.log(e)
        })
      } else { // 原有接口
        receiveCpsH5Coupon(obj, this.access_token).then(res => {
          this.conponRes(res)
        }).catch(e => {
          console.log(e)
        })
      }
    },
    // 小程序广点通上报
    gdtReport() {
      if (this.isApp === 'minwx' && (qz_gdt || gdt_vid)) {
        // 小程序url拼接existed（0-新用户 1-老用户）
        // 其他手机号验证码登录 newly：是否新用户（1-否 0-是）
        // 广告商上报
        let action_type = ''
        if (this.isApp === 'minwx') {
          action_type = getQueryString('existed') === '0' ? 'REGISTER' : 'LOGIN'
        } else if (this.isApp === 'other') {
          action_type = this.$root.newly === 0 ? 'REGISTER' : 'LOGIN'
        }
        const data = {
          cid: this.user_cid || localStorage.getItem('didacoupontemeplete_cid'),
          type: 2, // 1:发生点击；2:发生注册/登陆后上报
          action_type, // REGISTER：注册；LOGIN：登陆
          click_id: qz_gdt || gdt_vid
        }
        tencentattribution(data, this.access_token).then(res => {
          console.log(res)
        })
      }
    },
    conponRes(res) {
      if (res.data.code === 0) {
        this.gdtReport()
        this.loginstatus = true
        this.$didafe.toast(res.data.msg || res.data.message, { wordWrap: 'auto' })
        this.dataForCoupon.isget = true
        this.couponList = res.data.ret && res.data.ret.couponList ? res.data.ret.couponList : []
        this.totalValue = res.data.ret && res.data.ret.totalValue ? res.data.ret.totalValue : ''
        if (res.data.ret && res.data.ret.guideData) {
          this.guideData = res.data.ret.guideData
        }
        this.backgroundImage = this.title_image || 'https://static.didapinche.com/pics/g/u1tswx9392pWEBHF-844%E5%A4%87%E4%BB%BD%203.png'
        /* S 微信渠道埋点 */
        if (gdt_vid) {
          this.wxMKTAPI()
        }
        /* E 微信渠道埋点 */
      } else if (res.data.code === 534) {
        // 该请求不符合规范
        this.$didafe.toast(res.data.msg || res.data.message, { wordWrap: 'auto' })
        localStorage.removeItem('didacoupontemeplete_phone')
        localStorage.removeItem('didacoupontemeplete_cid')
        localStorage.removeItem('didacoupontemeplete_token')
        this.loginstatus = false
        if (this.isApp === 'app') {
          window.location = 'didapinche://home'
        } else if (this.isApp === 'minwx') {
          // 无pid 跳转首页
          // eslint-disable-next-line no-undef
          app_lient.redirectTo({ url: './index' })
        } else {
          window.location = 'https://www.didapinche.com/adh5/static/toapp/toapp.html'
        }
      } else if (res.data.code === 401) {
        localStorage.removeItem('didacoupontemeplete_phone')
        localStorage.removeItem('didacoupontemeplete_cid')
        localStorage.removeItem('didacoupontemeplete_token')
        this.$didafe.toast(res.data.msg || res.data.message, { wordWrap: 'auto' })
      } else {
        this.$didafe.toast(res.data.msg || res.data.message, { wordWrap: 'auto' })
      }
    },
    // 优惠券规则转换成数组，ui样式要求每条前面有原点（如果接口规则给的是字符串的话）
    transCouponMsg(msg) {
      let str = ''
      let arr = []
      str = msg.replace(/\n/g, '\\n').replace(/n\\/g, '')
      // str = msg.replace(/\n/g, '\\n').replace(/n\\/g, '').replace(/\\n/g, '\n');
      arr = str.split('\\n')
      return arr
    },
    // 显示优惠券详情弹窗
    showcouponMsgFn() {
      this.isPop = 1
    },
    // 关闭弹窗
    closePop() {
      this.isPop = 0
    },
    wxh5LoginSuccess(phone) {
      localStorage.setItem('didacoupontemeplete_phone', phone)
      // 登录后重置用户信息
      this.loginSuccess()
      const newdata = {
        phone: phone,
        openid: this.wxopenId, // 上一次的wxopenId
        accessToken: this.wxAccessToken // 上一次的wxopenId
      }
      official(newdata).then(() => {
        // 此处静默登录后期可以注释
        // this.openid = res.data;
      }).catch(() => {})
    },
    // 登陆成功
    loginSuccess() {
      // 领取优惠券
      this.dataForCoupon.tel = localStorage.getItem('didacoupontemeplete_phone')
      this.user_cid = localStorage.getItem('didacoupontemeplete_cid')
      this.access_token = localStorage.getItem('didacoupontemeplete_token')
      // if (typeof Dida !== 'undefined') {
      //   Dida.send('view', {
      //     code: '领券模板_点击领取优惠券',
      //     data: {
      //       name: '领券模板_点击领取优惠券',
      //       app_user_cid: this.user_cid
      //     }
      //   });
      // }
      this.isCouponGet().then(() => {
        if (!this.dataForCoupon.isget && !this.dataForCoupon.isover) {
          this.getCouponFn()
        } else {
          // 领取过，但仍点击了验证码登录的领取按钮
          addStat2('领券模板_点击领取优惠券', CID, goodCid, this.$root.envir) // 添加埋点
        }
      }).catch(() => {})
    },
    // app分享按钮点亮(如配置可分享再调用此方法点亮)
    shareByApp(data) {
      const share_info = {
        title: data.title,
        detail: data.subtitle,
        url: originLink + window.location.pathname + search,
        imgurl: data.img_url
      }
      shareByAppBtn(share_info)
    },
    // 微信二次分享
    wxSencondShare(data) {
      if (Env.inWechat) {
        // 微信二次分享
        const wxObj = {
          title: data.title,
          desc: data.subtitle,
          link: originLink + window.location.pathname + search,
          imgUrl: data.img_url,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
        }
        shareByWX(wxObj)
      }
    },
    // 微信广告渠道领券页数据监测
    wxMKTAPI() {
      let url = window.location.href
      url = url.replace(/^https/, 'http')
      const action_time = Math.floor((new Date().getTime()) / 1000)
      const obj = {
        url: url,
        action_time: action_time,
        click_id: gdt_vid,
        app_name: 'gzh_didachuxing',
        action_type: 'RESERVATION'
      }
      wechatMKT(obj).then(res => {
        if (res.data.code === 0) {
          console.log('wx上报成功')
        } else {
          console.log('出错了')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@common/scss/util.rem.scss";

  $wh: 9; // 圆点宽高
  $dis: 10; // 圆点间距

  @mixin point-style {
    display: block;
    width: #{$wh}px;
    height: #{$wh}px;
    border-radius: 50%;
    background-color: rgba(255, 173, 60, 1);
    animation: loading-point 0.6s infinite ease-in-out;
  }
  #app {
    width: 100vw;
    background: #fff;
  }
  .loading-point {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    @include point-style;
    transform: translateX(-#{$wh + $dis}px);

    &::after {
      content: " ";
      @include point-style;
      position: absolute;
      right: -#{$wh + $dis}px;
      top: 0;
      animation-delay: 0.2s;
    }

    &::before {
      content: " ";
      @include point-style;
      position: absolute;
      right: -#{$wh + $dis + $wh + $dis}px;
      top: 0;
      animation-delay: 0.4s;
    }
  }

  @keyframes loading-point {
    0% {
      background-color: rgba(255, 173, 60, 1);
    }
    100% {
      background-color: rgba(255, 173, 60, 0.3);
    }
  }
</style>
<style lang="scss" scoped>
  body,html {
    overflow: hidden;
  }
  .App {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .main-content {
    flex: 1;
    overflow: auto;
  }

  .content-bot {
    flex: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
  }

  .blur {
    filter: blur(10px);
  }

  .loading {
    width: 100vw;
    height: 100vh;
    background: #fff;
  }

  .wrapper {
    padding: 0 0.3rem 0.76rem 0.3rem;
    background-size: 100vw auto;
    background-repeat: no-repeat;
  }

  .noscroll {
    height: 100vh;
    overflow: hidden;
  }

  .active-rule {
    position: absolute;
    top: 1.46rem;
    right: 0;
    width: 0.88rem;
    height: 0.92rem;
    text-align: center;
    font-size: 0.24rem;
    padding: 0.16rem 0 0 0.1rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.34rem;
    background: rgba(0, 0, 0, 0.30);
    border-radius: 0.24rem 0 0 0.24rem;
  }
</style>

